import _ from 'lodash';
import React, { ComponentType } from 'react';
import { TemplateCardProps } from '../TemplateCard/TemplateCard';
import { TemplateGalleryCard } from '@common/types';

export type TemplateListCardComponentProps = Pick<
  TemplateCardProps,
  'forceRender' | 'index' | 'template'
> & {
  isMobileView?: boolean;
};

export type ITemplateListCardComponent =
  ComponentType<TemplateListCardComponentProps>;

export type Props = {
  templates?: TemplateGalleryCard[];
  isMobileView: boolean;
  SSRFlow?: boolean;
  CardComponent: ITemplateListCardComponent;
  LoadingState: ComponentType<{ isMobileView?: boolean }>;
};

const TemplateCardListItems = ({
  templates,
  isMobileView,
  SSRFlow,
  CardComponent,
  LoadingState,
}: Props) => {
  const haveTemplates = _.size(templates) > 0;

  if (haveTemplates) {
    return (
      <>
        {_.map(templates, (template, index) => (
          <li key={template.id}>
            <CardComponent
              isMobileView={isMobileView}
              template={template}
              forceRender={SSRFlow}
              index={index}
            />
          </li>
        ))}
      </>
    );
  }

  return <LoadingState isMobileView={isMobileView} />;
};

export default TemplateCardListItems;
